import { ConfigurationError } from '@cian/peperrors/shared';

import { ERuntimeType } from '../manifest/index.js';

// eslint-disable-next-line import/no-restricted-paths
import type { IRuntime, IUIRuntime } from './interfaces.js';
// eslint-disable-next-line import/no-restricted-paths
import type { IAPIHandler, IAPIParametersHandler } from '../../browser/bundles/interfaces.js';

export function isUIRuntime<T extends IUIRuntime = IUIRuntime>(runtime: IRuntime): runtime is T {
  return runtime.type === ERuntimeType.UI;
}

export function assertIsUIRuntime<T extends IUIRuntime = IUIRuntime>(runtime: IRuntime): asserts runtime is T {
  if (!isUIRuntime<T>(runtime)) {
    throw new ConfigurationError({
      message: `Рантайм "${runtime.name}" не является UI`,
      domain: 'mf-registry.shared.runtime.helpers',
    });
  }
}

export function createAPIHandler<Result>(path: string, handler: IAPIHandler<Result>['handler']): IAPIHandler<Result>;
export function createAPIHandler<Parameters, Result>(
  path: string,
  handler: IAPIParametersHandler<Parameters, Result>['handler'],
): IAPIParametersHandler<Parameters, Result>;
export function createAPIHandler(
  path: string,
  handler: IAPIHandler<unknown>['handler'] | IAPIParametersHandler<unknown, unknown>['handler'],
): IAPIHandler<unknown> | IAPIParametersHandler<unknown, unknown> {
  return {
    path,
    handler,
  };
}
